import { QontyEmptyState } from "@components/QontyEmptyState";
import { QontyLoading } from "@components/QontyLoading";
import {
    NovedadesExportService,
    NovedadesExportServiceModel,
} from "@services/NovedadesExportService";
import { RefreshButton } from "@shared/designSystem/Button";
import {
    HorizontalContainer,
    TableCell,
    TableHeaderCell,
    TableHeaderContainer,
    TableRowContainer,
    VerticalContainer,
} from "@shared/designSystem/Containers";
import designSystemStyles from "@shared/styles/designSystemStyles";

import {
    ExportNovedadesEventListItem,
    useExportNovedadesEventsStepViewModel,
} from "./ExportNovedadesEventsStepScreenViewModel";

interface ExportNovedadesEventsStepScreenProps {
    process: NovedadesExportServiceModel.ProcessRecord;
    service: NovedadesExportService;
}

const columnWidths = {
    date: "18%",
    level: "12%",
    step: "18%",
    message: "52%",
};

const ExportNovedadesEventsStepScreen: React.FC<ExportNovedadesEventsStepScreenProps> = ({
    process,
    service,
}) => {
    const viewModel = useExportNovedadesEventsStepViewModel({
        processID: process.processID,
        service,
    });

    if (viewModel.loading) {
        return (
            <QontyLoading
                text={"Cargando eventos...".localized()}
                withQonty={true}
            />
        );
    }

    if (viewModel.error) {
        return (
            <QontyEmptyState
                text={viewModel.error}
                darkMode={false}
            />
        );
    }

    if (viewModel.rows.length === 0) {
        return (
            <QontyEmptyState
                text={"No hay eventos para mostrar.".localized()}
                darkMode={false}
            />
        );
    }

    return (
        <VerticalContainer
            height="100%"
            gap={designSystemStyles.gapMd}
            margin="0"
            paddingTop={designSystemStyles.paddingMd}
        >
            <TableHeaderContainer height={designSystemStyles.sizeRowMedium}>
                <TableHeaderCell text={"Fecha".localized()} width={columnWidths.date} />
                <TableHeaderCell text={"Nivel".localized()} width={columnWidths.level} />
                <TableHeaderCell text={"Paso".localized()} width={columnWidths.step} />
                <TableHeaderCell text={"Mensaje".localized()} width={columnWidths.message} />
            </TableHeaderContainer>
            <div style={{ display: "flex", flexDirection: "column", gap: designSystemStyles.gapNone, overflowY: "auto", flex: 1, minHeight: 0, width: "100%" }}>
                {viewModel.rows.map((row: ExportNovedadesEventListItem) => (
                    <TableRowContainer key={row.id}>
                        <TableCell text={row.date} width={columnWidths.date} truncate={true} />
                        <TableCell text={row.level} width={columnWidths.level} truncate={true} />
                        <TableCell text={row.step} width={columnWidths.step} truncate={true} />
                        <TableCell text={row.message} width={columnWidths.message} truncate={true} />
                    </TableRowContainer>
                ))}
            </div>
        </VerticalContainer>
    );
};

export default ExportNovedadesEventsStepScreen;
